import * as React from 'react';
import { ComponentType } from 'react';
import LeafletViewerSkeleton from '../components/LeafletViewer/LeafletViewerSkeleton';
import { SlugType } from '../../Base/types/SlugType';

export default function withLeaflet(WrapperComponent: ComponentType<any>, leafletSlug: SlugType, props: any) {

    return <LeafletViewerSkeleton />;
}
